module.exports = __webpack_public_path__ + "static/media/motion-life.397b0934.gif";